import React from 'react';
import {Container, Grid} from "semantic-ui-react";
import greenTicketsLogo from "../resources/images/green-tickets-logo.png";
import StaticText from "./StaticText";

export default () => <div className="footer">
    <div className="line"/>
    <Container>
        <Grid>
            <Grid.Row>
                <Grid.Column width={4}>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row divided centered>
                <Grid.Column width={11}>
                    <strong>SailScanner</strong><br />
                    <StaticText label="footer" />
                </Grid.Column>
                <Grid.Column width={4}>
                    <a href="https://www.greentickets.app" target="_blank"><img src={greenTicketsLogo} alt="Green Tickets - Building the Europen travel planner of the future." style={{maxWidth: "100%"}} /></a>
                    <strong>Powered by <a href="https://www.greentickets.app" target="_blank">Green Tickets</a></strong><br/>
                    <a href="https://www.greentickets.app" target="_blank">greentickets.app</a> - building the European travel planner of the future. Comparing all modes of transport, door-to-door, on cost, duration and climate impact.
                    <br/>
                    <br/>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </Container>
</div>
;


// WEBPACK FOOTER //
// ./src/components/Footer.js